import { render, staticRenderFns } from "./Down.vue?vue&type=template&id=7e4fb6c6"
import script from "./Down.vue?vue&type=script&lang=js"
export * from "./Down.vue?vue&type=script&lang=js"
import style0 from "./Down.vue?vue&type=style&index=0&id=7e4fb6c6&prod&lang=scss&scroped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports